import './FooterInfo.css'
import { Link } from 'react-router-dom'
import { Button } from '@mantine/core'
import { useAppContext } from '../../../context/AppState/AppContext'
import { renderIcon } from '../../../utils/icon-diccionary'

export default function FooterInfo() {
   const { jsonTexts } = useAppContext();
   const { content } = jsonTexts.footer
   const { logoContainer, contactContainer, socialMediaContainer } = content



   return (
      <div className='footer-info-container'>
         {logoContainer.show &&
            <div className='footer-logo-container'>
               <div className='footer-column-container'>
                  < img className='footer-logo-image' src={logoContainer.logo_path} alt='logo' />
                  <Button variant='outline' color={'#FFF'} component={Link} to={logoContainer.buttonContact.redirectTo} w='100%' >{logoContainer.buttonContact.text}</Button>
               </div>
            </div>
         }
         {contactContainer &&
            <div className='footer-contact-container'>
               <div className='footer-column-container'>
                  <h4 className='footer-column-title'>{contactContainer.title}</h4>

                  {contactContainer.items?.map((item, idx) => (
                     <Link key={`${item.text}-${idx}`}
                        to={item.redirectTo}
                        className='footer-item-container'
                        target={item.target ?? null}>

                        {item.icon && renderIcon(item.icon)}
                        <span className='footer-item-text'>{item.text}</span>
                     </Link>
                  ))}
               </div>
            </div>
         }
         {socialMediaContainer.show &&
            <div className='footer-socials-container'>
               <div className='footer-column-container'>
                  <h4 className='footer-column-title'>{socialMediaContainer.title}</h4>
                  {socialMediaContainer.items?.map((item, idx) => (
                     <Link key={`${item.text}-${idx}`}
                        to={item.redirectTo}
                        className='footer-item-container'
                        target={item.target ?? null}>

                        {item.icon && renderIcon(item.icon)}
                        <span className='footer-item-text'>{item.text}</span>
                     </Link>
                  ))}
               </div>
            </div>}
      </div>
   )
}
